import cn from 'classnames';

import { SUBMITTING_TEXT } from 'lib/constants';

const Button = ({
  children = 'Continue',
  className = '',
  disabled = false,
  isSubmitting = false,
  onClick = () => {},
  submittingText = SUBMITTING_TEXT,
  type = 'button',
  variation = 'Primary',
  ariaLabel,
  ...restProps
}) => {
  const buttonText = isSubmitting ? submittingText : children;

  return (
    <button
      type={type}
      className={cn(className, 'btn', `btn${variation}`)}
      onClick={onClick}
      disabled={isSubmitting || disabled}
      aria-label={ariaLabel}
      {...restProps}
    >
      {buttonText}
    </button>
  );
};

Button.propTypes = {
  onClick: PropTypes.func,
  isSubmitting: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  ariaLabel: PropTypes.string,
  submittingText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.node,
  type: PropTypes.string,
  variation: PropTypes.oneOf([
    'Primary',
    'Secondary',
    'Caution',
    'Ghost',
    'TextPrimary',
    'TextSecondary',
    'Outlined',
    'OutlinePrimary',
    'OutlineSecondary',
    'Pill',
    'PillOutline',
  ]),
  buttonTextSizeClassName: PropTypes.string,
};

export default Button;
